import React, { useRef, useEffect, useState } from "react";

const TextareaInput = React.forwardRef(
  (
    {
      id,
      label,
      placeholder,
      className = "",
      labelClass = "",
      textareaClass = "",
      error,
      register,
      isOpen,
      ...props
    },
    ref
  ) => {
    const localRef = useRef(null);
    const [isOpenTrue, setIsOpenTrue] = useState(isOpen);

    // When accordion opens, adjust height

    useEffect(() => {
      setIsOpenTrue(isOpen);
    }, [isOpen]);
    useEffect(() => {
      if (isOpen && localRef.current) {
        localRef.current.style.height = "auto";
        localRef.current.style.height = `${localRef.current.scrollHeight}px`;
      }
    }, [isOpenTrue]);

    return (
      <div key={id} className={`flex flex-col gap-3 ${className}`}>
        {label && (
          <label htmlFor={id} className={`body-copy-small-text ${labelClass}`}>
            {label}
          </label>
        )}

        <textarea
          id={id}
          rows={2}
          ref={(el) => {
            if (typeof ref === "function") ref(el);
            else if (ref) ref.current = el;
            localRef.current = el;
          }}
          placeholder={placeholder}
          className={`text-20px-23px text-ff-purple rounded-[20px] px-5 py-3 w-full outline-none border-none resize-none ${textareaClass}`}
          onInput={(e) => {
            e.currentTarget.style.height = "auto";
            e.currentTarget.style.height = `${e.currentTarget.scrollHeight}px`;
          }}
          {...register}
          {...props}
        />

        {error && <p className="text-red-500 text-xs mt-1">{error.message}</p>}
      </div>
    );
  }
);

TextareaInput.displayName = "TextareaInput";
export default TextareaInput;
